import { defineStore } from 'pinia'

const STORAGE_KEY = 'fbc-cart'

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch (e) {
    return []
  }
}

export const useCartStore = defineStore('cart', {
  state: () => ({
    items: loadFromStorage(), // [{ productId, name, size, price, qty }]
  }),
  getters: {
    itemCount: (state) => state.items.reduce((sum, i) => sum + i.qty, 0),
    subtotal: (state) => state.items.reduce((sum, i) => sum + i.price * i.qty, 0),
  },
  actions: {
    addItem(item) {
      const existing = this.items.find(
        (i) => i.productId === item.productId && i.size === item.size
      )
      if (existing) {
        existing.qty += item.qty
      } else {
        this.items.push({ ...item })
      }
      this.persist()
    },
    updateQty(productId, size, qty) {
      const item = this.items.find((i) => i.productId === productId && i.size === size)
      if (item) item.qty = qty
      this.persist()
    },
    removeItem(productId, size) {
      this.items = this.items.filter((i) => !(i.productId === productId && i.size === size))
      this.persist()
    },
    clear() {
      this.items = []
      this.persist()
    },
    persist() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items))
    },
  },
})
